import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmationDialog } from '../../../../lib/components';
import Util from '../../../../misc/util';

export type DefaultValuesFields = {
  hasBudget: boolean;
  hasBenefitSet: boolean;
};

export const defaultValuesContext = ({ hasBudget, hasBenefitSet }: DefaultValuesFields) => {
  if (hasBudget && hasBenefitSet) return 'BOTH';
  return hasBudget ? 'BUDGET' : 'BENEFIT_SET';
};

export const nextMonthLabel = () => {
  const nextMonth = new Date();
  nextMonth.setDate(1);
  nextMonth.setMonth(nextMonth.getMonth() + 1);
  return Util.formatDateToMonthYear(nextMonth);
};

type Props = DefaultValuesFields & {
  open: boolean;
  onApply: () => void;
  onDecline: () => void;
};

export const ApplyDefaultsDialog: FC<Props> = ({
  open,
  hasBudget,
  hasBenefitSet,
  onApply,
  onDecline
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmationDialog
      open={open}
      variant="question"
      width="440px"
      title={t('company:APPLY_DEFAULTS_DIALOG_TITLE')}
      contentText={t('company:APPLY_DEFAULTS_DIALOG_TEXT', {
        context: defaultValuesContext({ hasBudget, hasBenefitSet }),
        nextMonth: nextMonthLabel()
      })}
      confirmButtonText={t('company:APPLY_DEFAULTS_CONFIRM')}
      cancelButtonText={t('company:APPLY_DEFAULTS_DECLINE')}
      onConfirm={onApply}
      onCancel={onDecline}
    />
  );
};
